import React, { createContext, useContext, useState, useCallback } from 'react';

const EnrolmentModalCtx = createContext({ open: false, show: () => {}, hide: () => {} });

export const EnrolmentModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaults, setDefaults] = useState({});

  const show = useCallback((prefill = {}) => {
    setDefaults(prefill);
    setOpen(true);
  }, []);
  const hide = useCallback(() => setOpen(false), []);

  return (
    <EnrolmentModalCtx.Provider value={{ open, show, hide, defaults }}>
      {children}
    </EnrolmentModalCtx.Provider>
  );
};

export const useEnrolmentModal = () => useContext(EnrolmentModalCtx);
